import { inject, Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class PaginatorTranslations extends MatPaginatorIntl {
  override nextPageLabel = ''; // No tooltip
  override previousPageLabel = ''; // No tooltip

  translate = inject(TranslateService);

  OF_LABEL = this.translate.instant('PAGINATOR.OF_LABEL');

  constructor() {
    super();

    this.translate.onLangChange.pipe(
      takeUntilDestroyed()
    ).subscribe(() => {
      this.getAndInitTranslations();
    });

    this.getAndInitTranslations();
  }

  getAndInitTranslations(): void {
    this.translate
      .get([
        'PAGINATOR.ITEMS_PER_PAGE',
        'PAGINATOR.OF_LABEL',
      ]).pipe(
      take(1)
    ).subscribe(translation => {
      this.itemsPerPageLabel =
        translation['PAGINATOR.ITEMS_PER_PAGE'];
      this.OF_LABEL = translation['PAGINATOR.OF_LABEL'];
      this.changes.next();
    });
  }

  getRangeLabel = (
    page: number,
    pageSize: number,
    length: number,
  ) => {
    if (length === 0 || pageSize === 0) {
      return `0 ${this.OF_LABEL} ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex =
      startIndex < length
        ? Math.min(startIndex + pageSize, length)
        : startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} ${
      this.OF_LABEL
    } ${length}`;
  };
}
